type ModelProvider = 'openai' | 'google' | 'anthropic'

interface ModelConfig {
  displayName: string
  provider: ModelProvider
  /** Gateway model ID in format "provider/model" for Vercel AI Gateway */
  gatewayModelId: string
}

export const languageModels: Record<string, ModelConfig> = {
  'gpt-5-mini': {
    displayName: 'GPT-5 Mini',
    provider: 'openai',
    gatewayModelId: 'openai/gpt-5-mini',
  },
  'gemini-3-flash-preview': {
    displayName: 'Gemini 3 Flash Preview',
    provider: 'google',
    gatewayModelId: 'google/gemini-3-flash-preview',
  },
  'gemini-3.1-pro-preview': {
    displayName: 'Gemini 3.1 Pro',
    provider: 'google',
    gatewayModelId: 'google/gemini-3.1-pro-preview',
  },
  'gemini-2.5-flash-preview-09-2025': {
    displayName: 'Gemini 2.5 Flash Preview',
    provider: 'google',
    gatewayModelId: 'google/gemini-2.5-flash-preview-09-2025',
  },
  'gpt-5.2': {
    displayName: 'GPT-5.2',
    provider: 'openai',
    gatewayModelId: 'openai/gpt-5.2',
  },
}
